module.exports = __webpack_public_path__ + "img/machine-mobile.1f704863.jpg";